(function () {
  const drawer = document.querySelector("[data-mobile-menu-drawer]");
  const backdrop = document.querySelector("[data-mobile-menu-backdrop]");
  const toggleButtons = document.querySelectorAll("[data-mobile-menu-toggle]");
  const closeButtons = document.querySelectorAll("[data-mobile-menu-close]");
  const submenuTriggers = document.querySelectorAll(
    "[data-mobile-submenu-trigger]",
  );
  const submenuBackButtons = document.querySelectorAll(
    "[data-mobile-submenu-back]",
  );

  let isOpen = false;
  let activeSubmenu = null;

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;

    drawer.classList.remove("-translate-x-full");
    drawer.classList.add("translate-x-0");
    backdrop.classList.remove("opacity-0", "pointer-events-none");
    backdrop.classList.add("opacity-100", "pointer-events-auto");

    document.body.classList.add("overflow-hidden");

    drawer.setAttribute("aria-hidden", "false");
    toggleButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", "true");
    });

    requestAnimationFrame(() => {
      const focusable = getFocusableElements(drawer);
      if (focusable.length > 0) {
        focusable[0].focus();
      }
    });

    document.addEventListener("keydown", handleKeydown);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;

    if (activeSubmenu) {
      closeSubmenu(activeSubmenu, false);
    }

    drawer.classList.remove("translate-x-0");
    drawer.classList.add("-translate-x-full");
    backdrop.classList.remove("opacity-100", "pointer-events-auto");
    backdrop.classList.add("opacity-0", "pointer-events-none");

    document.body.classList.remove("overflow-hidden");

    drawer.setAttribute("aria-hidden", "true");
    toggleButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });

    const lastTrigger = document.querySelector("[data-mobile-menu-toggle]");
    if (lastTrigger) {
      lastTrigger.focus();
    }

    document.removeEventListener("keydown", handleKeydown);
  }

  function openSubmenu(index) {
    const panel = document.querySelector(
      `[data-mobile-submenu-panel="${index}"]`,
    );
    const trigger = document.querySelector(
      `[data-mobile-submenu-trigger="${index}"]`,
    );

    if (!panel) return;

    activeSubmenu = index;

    panel.classList.remove("hidden");
    requestAnimationFrame(() => {
      panel.classList.remove("translate-x-full");
      panel.classList.add("translate-x-0");
    });

    panel.setAttribute("aria-hidden", "false");
    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }

    requestAnimationFrame(() => {
      const backBtn = panel.querySelector("[data-mobile-submenu-back]");
      if (backBtn) {
        backBtn.focus();
      }
    });
  }

  function closeSubmenu(index, returnFocus = true) {
    const panel = document.querySelector(
      `[data-mobile-submenu-panel="${index}"]`,
    );
    const trigger = document.querySelector(
      `[data-mobile-submenu-trigger="${index}"]`,
    );

    if (!panel) return;

    activeSubmenu = null;

    panel.classList.remove("translate-x-0");
    panel.classList.add("translate-x-full");

    panel.setAttribute("aria-hidden", "true");
    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }

    setTimeout(() => {
      if (!panel.classList.contains("translate-x-0")) {
        panel.classList.add("hidden");
      }
    }, 300);

    if (returnFocus && trigger) {
      trigger.focus();
    }
  }

  function handleKeydown(e) {
    if (e.key === "Escape") {
      if (activeSubmenu !== null) {
        closeSubmenu(activeSubmenu);
      } else {
        closeDrawer();
      }
    }

    if (e.key === "Tab") {
      const container =
        activeSubmenu !== null
          ? document.querySelector(
              `[data-mobile-submenu-panel="${activeSubmenu}"]`,
            )
          : drawer;

      const focusable = getFocusableElements(container);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  toggleButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener("click", closeDrawer);
  });

  backdrop.addEventListener("click", closeDrawer);

  submenuTriggers.forEach((btn) => {
    btn.addEventListener("click", () => {
      const index = btn.getAttribute("data-mobile-submenu-trigger");
      openSubmenu(index);
    });
  });

  submenuBackButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (activeSubmenu !== null) {
        closeSubmenu(activeSubmenu);
      }
    });
  });
})();
